import { useState } from 'react';
import { Button, ButtonGroup, Paper, Stack } from '@mui/material';
import CompletionRateChart from './CompletionRateChart';
import PaymentTypeChart from './PaymentTypeChart';
import { PaymentPercentages } from '@/hooks/useOrderStats';

interface Props {
    isLoading: boolean;
    paymentData: PaymentPercentages;
    completionData?: { completed: number; rejected: number };
}

const PieChartsToggle = ({ isLoading, paymentData, completionData }: Props) => {
    const [activeChart, setActiveChart] = useState<'completion' | 'payment'>('completion');

    return (
        <Paper sx={{ p: 2 }}>
            <Stack spacing={2}>
                <ButtonGroup fullWidth size="small" aria-label="Toggle charts">
                    <Button
                        variant={activeChart === 'completion' ? 'contained' : 'outlined'}
                        onClick={() => setActiveChart('completion')}
                    >
                        Aceptación
                    </Button>
                    <Button
                        variant={activeChart === 'payment' ? 'contained' : 'outlined'}
                        onClick={() => setActiveChart('payment')}
                    >
                        Pago
                    </Button>
                </ButtonGroup>

                {activeChart === 'completion' ? (
                    <CompletionRateChart isLoading={isLoading} data={completionData} />
                ) : (
                    <PaymentTypeChart isLoading={isLoading} data={paymentData} />
                )}
            </Stack>
        </Paper>
    );
}

export default PieChartsToggle;
